// Inter is the body font of Trellis, and the library does not bundle it.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@akaal/trellis-ui/styles.css'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { configureApiClient } from '@/api/client'
import App from '@/App.vue'
import { readConfig } from '@/config'
import { i18n } from '@/i18n'
import { configureLiveUpdates } from '@/live/socket'
import { installErrorTracking, trackSignedInUser } from '@/monitoring/glitchtip'
import { router } from '@/router'
import { notFoundLocation } from '@/router/not-found'
import { installDocumentTitle } from '@/shell/title'
import { useAuthStore } from '@/stores/auth'

const config = readConfig()
const app = createApp(App)

installErrorTracking(app, router, config)

configureApiClient({
  baseUrl: config.apiBaseUrl,
  // A 404 from the API is a hidden or cross-company resource (MRS 9). The
  // address stays in the bar; the page becomes the shared not-found view.
  onNotFound: () => {
    void router.replace(notFoundLocation(router.currentRoute.value))
  },
})
configureLiveUpdates(config.liveUpdates)

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18n)

const auth = useAuthStore(pinia)
trackSignedInUser(() => auth.me?.id ?? null)
installDocumentTitle(router, i18n.global.t)

app.mount('#app')
